module.exports = __webpack_public_path__ + "static/media/resume.9c23863c.pdf";